"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchResultState = void 0;
const React = require("react");
const index_1 = require("../index");
const app_1 = require("app");
const useSearchResultState = (tabsConfig) => {
    const { tabs, totalResultCount, initialUiState, selectedTab, tabsResultCountMap, isHitsAndFiltersLoading, setSelectedTab, setIsHitsAndFiltersLoading, updateTabResultCount, query: initialQuery, dictionary: tabDictionary, isTabsLoading, isZeroResult, isSubsequentRef, configData, lastUserAction, setLastUserAction, } = tabsConfig;
    const { isDocumentPage, language, gtmPageName } = configData;
    const { dictionary, isDictionaryLoaded } = (0, index_1.useSearchResultDictionary)(selectedTab, configData, tabDictionary);
    const [isMobileFiltersOpen, setIsMobileFiltersOpen] = React.useState(false);
    (0, index_1.useSyncUrlParams)(selectedTab, isDocumentPage);
    const { tiles, resultCount, isContentTranslationLoading, isProductExtraDataLoading, isTabZeroResult, } = (0, index_1.useSearchResultHits)(selectedTab, tabsResultCountMap, language, isDocumentPage, dictionary);
    const { filters, hierarchyFilters, selectedFilterOptionsCount, clearAllRefinements } = (0, index_1.useSearchResultFilters)(selectedTab, dictionary);
    const { currentPage, totalPages, pageSize, refinePage, refinePageSize } = (0, index_1.useSearchResultPagination)(selectedTab.key, (tabsResultCountMap === null || tabsResultCountMap === void 0 ? void 0 : tabsResultCountMap[selectedTab.key]) || 0);
    const { isLoading, isHitsLoading, hasError, setIsHitsLoading } = (0, index_1.useSearchResultLoading)(tiles, isTabZeroResult, isContentTranslationLoading, isProductExtraDataLoading, isDictionaryLoaded, isHitsAndFiltersLoading, isTabsLoading, setIsHitsAndFiltersLoading);
    const { query, refineQuery, clearQuery } = (0, index_1.useSearchResultQuery)(initialQuery, setIsHitsAndFiltersLoading, setLastUserAction);
    const { updateSnapshot, resetToPreviousSnapshot } = (0, index_1.useResetFilterToPreviousSnapshot)();
    const isDesktop = (0, app_1.useDesktop)();
    (0, index_1.useUpdateTabResultCount)(selectedTab.key, lastUserAction, updateTabResultCount);
    (0, index_1.useSyncUrlHistoryAndFilters)(tabs, selectedTab, configData, setSelectedTab, setLastUserAction, setIsHitsAndFiltersLoading);
    (0, index_1.useSearchResultGTM)(initialQuery, totalResultCount, lastUserAction, isSubsequentRef, gtmPageName);
    return React.useMemo(() => ({
        // Tabs
        tabs,
        initialUiState,
        isTabsLoading,
        selectedTab,
        query,
        isHitsAndFiltersLoading,
        setSelectedTab,
        setIsHitsAndFiltersLoading,
        updateTabResultCount,
        dictionary: tabDictionary,
        configData,
        //Filters
        filters,
        hierarchyFilters,
        selectedFilterOptionsCount,
        isMobileFiltersOpen,
        setIsMobileFiltersOpen,
        updateSnapshot,
        clearAllRefinements,
        resetToPreviousSnapshot,
        // Loading
        isLoading,
        isHitsLoading,
        hasError,
        setIsHitsLoading,
        // Tiles
        tiles,
        isTabZeroResult,
        isZeroResult,
        resultCount,
        // User Action
        lastUserAction,
        setLastUserAction,
        // Pagination
        currentPage,
        totalPages,
        pageSize,
        refinePage,
        refinePageSize,
        // Search Box
        refineQuery,
        clearQuery,
        isDesktop,
    }), [
        tabs,
        initialUiState,
        isTabsLoading,
        selectedTab,
        query,
        isHitsAndFiltersLoading,
        setSelectedTab,
        setIsHitsAndFiltersLoading,
        updateTabResultCount,
        tabDictionary,
        configData,
        filters,
        hierarchyFilters,
        selectedFilterOptionsCount,
        isMobileFiltersOpen,
        setIsMobileFiltersOpen,
        updateSnapshot,
        clearAllRefinements,
        resetToPreviousSnapshot,
        isLoading,
        isHitsLoading,
        hasError,
        setIsHitsLoading,
        tiles,
        isTabZeroResult,
        isZeroResult,
        resultCount,
        lastUserAction,
        setLastUserAction,
        currentPage,
        totalPages,
        pageSize,
        refinePage,
        refinePageSize,
        refineQuery,
        clearQuery,
        isDesktop,
    ]);
};
exports.useSearchResultState = useSearchResultState;
